import { render, staticRenderFns } from "./p05.vue?vue&type=template&id=1b9030ec&scoped=true&"
import script from "./p05.vue?vue&type=script&lang=js&"
export * from "./p05.vue?vue&type=script&lang=js&"
import style0 from "./p05.vue?vue&type=style&index=0&id=1b9030ec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9030ec",
  null
  
)

export default component.exports